if (!customElements.get('ak-gift-preview')) {
  class AkGiftPreview extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    const panel = this.closest('.ak-gift-options');
    if (!panel) return;

    this.occasionInput = panel.querySelector('[name="properties[Occasion]"]');
    this.recipientInput = panel.querySelector('[name="properties[Recipient name]"]');
    this.senderInput = panel.querySelector('[name="properties[Sender name]"]');
    this.messageInput = panel.querySelector('[name="properties[Gift message]"]');
    this.secretInput = panel.querySelector('[name="properties[Hide sender name]"]');
    this.occasionOutput = this.querySelector('[data-ak-preview-occasion]');
    this.recipientOutput = this.querySelector('[data-ak-preview-recipient]');
    this.senderOutput = this.querySelector('[data-ak-preview-sender]');
    this.messageOutput = this.querySelector('[data-ak-preview-message]');

    [this.occasionInput, this.recipientInput, this.senderInput, this.messageInput, this.secretInput].forEach((input) => {
      input?.addEventListener('input', () => this.compose());
      input?.addEventListener('change', () => this.compose());
    });

    this.compose();
  }

  compose() {
    this.dataset.updating = 'true';
    const occasion = this.occasionInput?.value.trim();
    const recipient = this.recipientInput?.value.trim();
    const sender = this.senderInput?.value.trim();
    const message = this.messageInput?.value.trim();
    const secret = this.secretInput?.checked;

    if (this.senderInput) this.senderInput.disabled = Boolean(secret);

    this.occasionOutput.textContent = occasion || this.dataset.occasionFallback;
    this.recipientOutput.textContent = recipient ? `For ${recipient}` : this.dataset.recipientFallback;
    this.messageOutput.textContent = message || this.dataset.messageFallback;
    this.senderOutput.textContent = secret
      ? this.dataset.secretFallback
      : sender
        ? `From ${sender}`
        : this.dataset.senderFallback;

    requestAnimationFrame(() => {
      this.dataset.updating = 'false';
    });
  }
  }

  customElements.define('ak-gift-preview', AkGiftPreview);
}
